import React, { Component } from "react";
import OlMap from "ol/Map";
import OlView from "ol/View";
import {
  Tile as TileLayer,
  Vector as VectorLayer,
  Image as ImageLayer,
} from "ol/layer";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
import olms from 'ol-mapbox-style/src/olms'
import EsriJSON from 'ol/format/EsriJSON';
import MVT from 'ol/format/MVT'
import MultiPolygon from "ol/geom/MultiPolygon";
import Point from "ol/geom/Point";
import {
  defaults as defaultControls,
  ScaleLine,
  OverviewMap,
} from "ol/control.js";
import {
  defaults as defaultInteractions,
  DragRotateAndZoom,
} from "ol/interaction.js";
import { OSM } from "ol/source";
import { fromLonLat } from "ol/proj";
import { Feature, Overlay } from "ol";
import ImageWMS from "ol/source/ImageWMS";
import { ZoomToExtent } from "ol/control.js";
import { View } from "ol";
import SimpleGeometry from "ol/geom/SimpleGeometry";
import { getCenter } from "ol/extent";
import { mapData, searchrdfquery } from "../../api/kugi";
import "./marker.css";
import queryString from "query-string";
import { Button } from "@material-ui/core";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import "ol/ol.css";
import {Fill, Style, Stroke, Circle} from 'ol/style'

// import ImageLayer from "ol/layer/Image";

class MapDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      center: [0, 0],
      zoom: 10,
      kx: 0,
      ky: 0,
      keterangan: "",
      idObject: "",
      loading: true,
      dataMap: null,
    };
  }

  componentDidMount() {
    const id = this.handleId(queryString.parse(this.props.location.search));
    console.log(id);
    this.handleFetch(id).then(() => {
      // const idData = queryString.parse(this.props.location.search);
      // const kategori = idData.id.toString();
      // if (kategori.length === 13)
      //   this.setState({ keterangan: "Batas Wilayah Desa", idObject: kategori });
      // else if (kategori.length === 5)
      //   this.setState({
      //     keterangan: "Batas Wilayah Kabupaten Kota",
      //     idObject: kategori,
      //   });
      // else if (kategori.includes("-"))
      //   this.setState({
      //     keterangan: "Batas Wilayah Kabupaten Kota dalam bentuk garis",
      //     idObject: kategori,
      //   });
      // else if (kategori.includes("T-"))
      //   this.setState({ keterangan: "Toponim", idObject: kategori });
      const scaleLineControl = new ScaleLine();
      const overviewMapControl = new OverviewMap({
        className: "ol-overviewmap ol-custom-overviewmap",
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
        ],
        collapseLabel: "\u00BB",
        label: "\u00AB",
        collapsed: true,
      });
      let vectorlayer = new VectorLayer({
        source: new VectorSource({
          format: new MVT(),
          url: 'https://geoservices.big.go.id/rbi/rest/services/Hosted/Rupabumi_Indonesia/VectorTileServer/tile/{z}/{y}/{x}.pbf'
        })
      })
      // vectorlayer.setStyle(olms.styleFunction(vectorlayer, 'https://geoservices.big.go.id/rbi/rest/services/Hosted/Rupabumi_Indonesia/VectorTileServer/resources/styles/root.json'))
      this.olmap = new OlMap({
        target: null,
        layers: [
          // new TileLayer({
          //   source: new OSM(),
          // }),
          vectorlayer
        ],
        // controls: defaultControls({
        //   attributionOptions: { collapsible: true },
        // }).extend([
        //   overviewMapControl,
        //   // scaleLineControl
        // ]),
        // interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
        view: new OlView({
          center: fromLonLat(this.state.center),
          zoom: this.state.zoom,
        }),
      });
      console.log("test");
      this.olmap.setTarget("map");
      // // const marker = new Overlay({
      // //   position: fromLonLat(this.state.center),
      // //   positioning: "center-center",
      // //   element: document.getElementById("markerData"),
      // //   className: "markerData",
      // //   id: "markerTitik",
      // // });
      // this.olmap.addOverlay(marker);
      // const GEO_URL =
      //   "http://localhost:8080/geoserver/big/ows?service=WFS&version=1.0.0&request=GetFeature&";
      // // let idFix;
      // // if (this.props.sublayer === "taswil_kabkot_ar") idFix = `${id}`;
      // // else idFix = `'${id}'`;
      // const url = `${GEO_URL}typeName=big%3Ataswil_kabkot_ar&maxFeatures=50&outputFormat=application%2Fld%2Bjson&CQL_FILTER=kdpkab=${idData}`;

      console.log(this.state.dataMap);
      // const geom = JSON.parse(this.state.dataMap)
      // const shape = new MultiPolygon(fromLonLat(this.state.dataMap))
      // console.log(shape)
      // const multipolygon = new GeoJSON()
      // const source = new VectorSource({
      //   // url: url,
      //   format: new GeoJSON(),
      //   // features: multipolygon
      // });
      // source.addFeatures(multipolygon.readFeatures(this.state.dataMap))

      // const layer = new VectorLayer({
      //   source: new VectorSource({
      //     features: [
      //       new Feature({
      //         geometry: new MultiPolygon(
      //           this.state.dataMap.features[0].wkt_geom
      //         ),
      //       }),
      //     ],
      //   }),
      // });

      // const geojson = new GeoJSON().readFeatures(this.state.dataMap);
      // console.log(geojson);
      // const poly = new MultiPolygon(this.state.dataMap.features[0].geometry);
      // console.log(poly);
      // const source = new VectorSource({
      //   format: new GeoJSON(),
      //   features: geojson,
      // });

      // const layer = new VectorLayer({
      //   source: source,
      //   visible: true,
      //   style: new Style({
      //     fill: new Fill({
      //       color: "red",
      //     }),
      //     stroke: new Stroke({
      //       color: "blue",
      //       lineDash: [3, 3],
      //       width: 2,
      //     }),
      //   }),
      // });

      // console.log(layer);
      // this.olmap.addLayer(layer);

      const image = new Circle({
        radius: 10,
        fill: new Fill ({
          color: "rgba(42,99,181, 0.3)",
        }),
        stroke: new Stroke({color: "rgb(73,122,194)", width: 5}),
      });

      const styles = {
        Point: new Style({
          image: image,
        }),
        LineString: new Style({
          stroke: new Stroke({
            color: "green",
            width: 1,
          }),
        }),
        MultiLineString: new Style({
          stroke: new Stroke({
            color: "rgb(73,122,194)",
            width: 5,
          }),
        }),
        MultiPoint: new Style({
          image: image,
        }),
        MultiPolygon: new Style({
          stroke: new Stroke({
            color: "rgb(73,122,194)",
            width: 1,
          }),
          fill: new Fill({
            color: "rgba(42,99,181, 0.3)",
          }),
        }),
        Polygon: new Style({
          stroke: new Stroke({
            color: "blue",
            lineDash: [4],
            width: 3,
          }),
          fill: new Fill({
            color: "rgba(0, 0, 255, 0.1)",
          }),
        }),
        GeometryCollection: new Style({
          stroke: new Stroke({
            color: "magenta",
            width: 2,
          }),
          fill: new Fill({
            color: "magenta",
          }),
          image: new Circle({
            radius: 10,
            fill: null,
            stroke: new Stroke({
              color: "magenta",
            }),
          }),
        }),
        Circle: new Style({
          stroke: new Stroke({
            color: "red",
            width: 2,
          }),
          fill: new Fill({
            color: "rgba(255,0,0,0.2)",
          }),
        }),
      };
      const styleFunction = function (feature) {
        return styles[feature.getGeometry().getType()];
      };

      const source2 = new VectorSource({
        url:
          "https://gold.big.go.id:8081/geoserver/big/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=big%3Ataswil_kabkot_ar&maxFeatures=50&outputFormat=application%2Fld%2Bjson&CQL_FILTER=kdpkab='32.76'",
        format: new GeoJSON(),
      });
      const vector2 = new VectorLayer({
        source: source2,
        visible: true,
        style: styleFunction
        // style: new Style({
        //   fill: new Fill({
        //     color: "green",
        //   }),
        //   stroke: new Stroke({
        //     color: "blue",
        //     lineDash: [3, 3],
        //     width: 2,
        //   }),
        // }),
      });
      console.log(source2);
      console.log(vector2);
      vector2.getSource().on("addfeature", (e) => {
        this.olmap.getView().fit(vector2.getSource().getExtent());
        this.olmap.getView().setZoom(13)
      });
      this.olmap.addLayer(vector2);

      // const source3 = new VectorSource({
      //   features: new GeoJSON().readFeatures()
      // })
      // console.log(source3)

      // const MAP_URL = "https://wms.redbit.co.id/geoserver/big/wms?";
      // let sourceDesa = new ImageWMS({
      //   url: `${MAP_URL}`,
      //   params: {
      //     LAYERS: "big:taswil_desa_ar",
      //     CQL_FILTER: `[kdepum = '${idData.id}']`,
      //   },
      //   serverType: "geoserver",
      // });
      // let layerDesa = new ImageLayer({
      //   source: sourceDesa,
      // });
      // this.olmap.addLayer(layerDesa);
      // // let layerExtent = new SimpleGeometry({
      // //   getExtent: layerDesa
      // // })
      // // console.log(layerExtent)
      // // this.olmap.getView().fit(layerDesa.getExtent(), this.olmap.getSize())
      // let sourceKotaAr = new ImageWMS({
      //   url: `${MAP_URL}`,
      //   params: {
      //     LAYERS: "big:taswil_kabkot_ar",
      //     CQL_FILTER: `[kdpkab = ${idData.id}]`,
      //   },
      //   serverType: "geoserver",
      // });
      // let layerKotaAr = new ImageLayer({
      //   source: sourceKotaAr,
      // });
      // this.olmap.addLayer(layerKotaAr);
      // let sourceKotaLn = new ImageWMS({
      //   url: `${MAP_URL}`,
      //   params: {
      //     LAYERS: "big:taswil_kabkot_ln",
      //     CQL_FILTER: `[object_id = '${idData.id}']`,
      //   },
      //   serverType: "geoserver",
      // });
      // let layerKotaLn = new ImageLayer({
      //   source: sourceKotaLn,
      // });
      // this.olmap.addLayer(layerKotaLn);
      // let sourceToponim = new ImageWMS({
      //   url: `${MAP_URL}`,
      //   params: {
      //     LAYERS: "big:toponim_pt",
      //     CQL_FILTER: `[object_id = '${idData.id}']`,
      //   },
      //   serverType: "geoserver",
      // });
      // let layerToponim = new ImageLayer({
      //   source: sourceToponim,
      // });
      // this.olmap.addLayer(layerToponim);
      this.setState({ loading: false });
      console.log(this.olmap);
    });
  }
  handleId = (id) => {
    if (id.id.includes("T-")) {
      if (id.id.includes("@")) return id.id;
      else return `@${id.id}`;
    } else {
      // if (id.id.includes("@")) {
      //   let idTest = id.id;
      //   let idFix = idTest.slice(0, 6);
      //   return idFix;
      // } else {
      let idTest = id.id;
      let idFix = idTest.slice(0, 5);
      return `${idFix}`;
      // }
    }
  };

  handleFetch = async (id) => {
    // await searchrdfquery("memilikiKOORDX", id, "")
    //   .then(async (resx) => {
    //     await searchrdfquery("memilikiKOORDY", id, "")
    //       .then((resy) => {
    //         const cx = resx.data[0].objek.split("^", 1);
    //         const cy = resy.data[0].objek.split("^", 1);
    //         this.setState({
    //           center: [parseFloat(cx[0]), parseFloat(cy[0])],
    //         });
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    let item
    item = {layer: 'big', sublayer: "toponim_pt", kategori: "object_id", host: 'https://gold.big.go.id:8081/geoserver/big/ows?service=WFS&version=1.0.0&request=GetFeature&maxFeatures=50&outputFormat=application%2Fld%2Bjson'}
    await mapData(item, 'T-141944').then(async (res) => {
      console.log(res.data);
      this.setState({ dataMap: res.data });
    });
  };

  userAction = () => {
    this.olmap.getView().setCenter(fromLonLat(this.state.center));
    this.olmap.getView().setZoom(10);
  };

  render() {
    return (
      <BlockUi
        blocking={this.state.loading}
        color="#497ac2"
        message="Loading..."
      >
        <div
          id="map"
          style={{
            width: "100%",
            height: "85vh",
            paddingTop: "5%",
            position: "relative",
          }}
        >
          {this.state.loading ? null : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                alignItems: "flex-start",
                position: "absolute",
                zIndex: 100,
                bottom: 0,
                left: 0,
                backgroundColor: "#ebebeb",
                borderRadius: "10px",
                marginLeft: "20px",
                marginBottom: "20px",
                padding: "10px",
              }}
            >
              {/* <div id="markerData" className="markerData" /> */}
              <h5>
                <b>{this.state.keterangan}</b>
              </h5>
              <h5>ID: {this.state.idObject}</h5>
              {this.state.keterangan === "Batas Wilayah Desa" ||
              this.state.keterangan ===
                "Batas Wilayah Kabupaten Kota dalam bentuk garis" ? null : (
                <h6 className="text">
                  X: {this.state.center[0]} Y: {this.state.center[1]}
                </h6>
              )}
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#497ac2",
                  color: "#FFF",
                  outline: "none",
                }}
                onClick={this.userAction}
              >
                recenter
              </Button>
            </div>
          )}
        </div>
      </BlockUi>
    );
  }
}

export default MapDetail;
